// extracted by mini-css-extract-plugin
module.exports = {"grid":"GridContainer_grid__4rf2s"};